module.exports = __webpack_public_path__ + "static/media/icon_fire.cc426c36.svg";